export const downloadA24 = 'https://a-bank.com.ua/24';
export const aBank24forBusiness = 'http://ab.a-bank.com.ua';
export const wu = 'https://www.westernunion.com/ua/uk/find-locations.html'; // transfers/wu banner button
export const payoneer = 'http://tracking.payoneer.com/aff_c?offer_id=512&aff_id=43317&url_id=1134'; // transfers/payoneer banner button

export const remitbee = 'https://www.remitbee.com/'; // transfers/remitbee banner button
export const globus = 'https://globusbank.com.ua/ua/hlobus.html';
export const chooseRiaServicePoint = 'https://www.riamoneytransfer.com/';
export const mobileAcquiringGooglePlay =
    'https://play.google.com/store/apps/details?id=ua.com.abank.pay';
export const terms = 'https://conditions-and-rules.a-bank.com.ua';
export const paymentsTerms =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Info_pay.pdf';
export const pensionTariffs =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zhovta_ua.pdf';
export const diia = 'https://erecovery.diia.gov.ua/';
export const AppGallery =
    'https://appgallery.huawei.com/app/C102212413?sharePrepath=ag&locale=uk_uk';
export const Itunes = 'https://itunes.apple.com/us/app/abank24/id1261267716?ls=1&mt=8';
export const paymentsSystem =
    'https://bank.gov.ua/ua/payments/payment-systems/d46d4d387e24410f9593a9413b1469a8';
export const depositHref = 'https://a-bank.com.ua/deposits#frame';
export const onlineDeposit = 'https://a-bank.com.ua/static/deposit/online_deposit_conditions.pdf';
export const aBankLogoSVG =
    'https://drive.google.com/drive/folders/1r0nfdC89h4rbf1nufc94y0AtkiYXybUm?usp=drive_link';
export const aBankFonts =
    'https://drive.google.com/file/d/1yJlrIYPWYA-M48kd1KWGZwDj_uORF-A7/view?usp=drive_link';

export const minfinLink = 'https://minfin.com.ua/company/a-bank/review/';
export const pbpCredit = 'https://t.me/chasti_abankbot';
export const rozetka = 'https://rozetka.com.ua/';
export const comfy = 'https://comfy.ua/dnipro/';
export const assol = 'https://assol.in.ua/';
export const ukrzoloto = 'https://ukrzoloto.ua/uk';
export const zolotoyvek = 'https://zolotoyvek.ua/ua';
export const shina = 'https://shina.ua/';
export const touch = 'https://touch.com.ua/ua';
export const yabloki = 'https://yabloki.ua/';
export const allo = 'https://allo.ua/';
export const epicentrk = 'https://epicentrk.ua/';
export const ktc = 'https://ktc.ua/';
export const moyo = 'https://www.moyo.ua/';
export const foxtrot = 'https://www.foxtrot.com.ua/';
export const jabko = 'https://jabko.ua/';
export const ctrs = 'https://www.ctrs.com.ua/';
export const pbp_api_docs = 'https://sites.google.com/a-bank.com.ua/api-abank?usp=sharing';
export const brend_thing_pbp =
    'https://drive.google.com/drive/folders/1mCdp33iHT4J3qNNsEtNsQNfXIRkTkFCQ';
export const recordVideoInterview85 = 'https://-abank-.playhunt.io/welcome/hfm01l93';
export const recordVideoInterview89 = 'https://-abank-.playhunt.io/welcome/hfhpnk3g';
export const atbMarketPromo1 = 'https://www.atbmarket.com/promo/micni';
export const atbMarketPromo2 =
    'https://podorozhnyk.ua/promo/znizhka-3percent-v-aptekah-podorozhnik-z-kartkoyu-atb/';
export const businessBannerAward =
    'https://smebanking.agency/digital-banking-2025-top20-sme-banks-by-countries/';
export const expressEnergyEpicentr = 'https://b2b.epicentrk.ua/shop/energoobespechenie/';
export const expressEnergyFoxtrot = 'https://www.foxtrot.com.ua/uk/shop/generators.html';
export const expressEnergyDarex = 'https://darex.energy/engine/baudouin-uk/';
export const expressEnergyAnthurium = 'https://anthurium.energy/';
export const expressEnergyGeneracia = 'https://generacia.energy/';
export const expressEnergyDosvid = 'https://www.dosvid.com.ua/about-us/';
export const expressEnergyCitrus = 'https://www.ctrs.com.ua/mobilnye-istochniki-pitaniya/';
export const expressEnergySolarGarden = 'https://www.solargarden.com.ua/';
export const expressEnergyOnlySolar = 'https://onlysolar.in.ua/';
export const applyDarex =
    'https://corploans.a-bank.com.ua/?utm_source=google&utm_medium=organic&utm_campaign=darex&utm_content=link&utm_term=partner';
export const applyOnlySolar =
    'https://corploans.a-bank.com.ua/?utm_source=google&utm_medium=organic&utm_campaign=onlysolar&utm_content=partner';
export const applyAnthurium =
    'https://corploans.a-bank.com.ua/?utm_source=google&utm_medium=cpc&utm_campaign=anthurium&utm_content=energy';
export const tarrifsKidCard =
    'https://conditions-and-rules.a-bank.com.ua/media/uploads/Cart/%D0%9Aids.pdf';
export const pr_page_wiget_link = 'https://stage.snapwidget.com/embed/599887';
export const pr_page_wiget_rabota_facebook = 'https://snapwidget.com/embed/1095721';
export const pr_page_wiget_rabota_instagram = 'https://snapwidget.com/embed/1095720';
export const pr_page_wiget_oficial_instagram = 'https://snapwidget.com/embed/1096392';
export const pr_page_wiget_tiktok = 'https://snapwidget.com/embed/1095725';
export const pr_page_wiget_youtube = 'https://snapwidget.com/embed/1095918';

export const pr_page_subscribe_tiktok = 'https://www.tiktok.com/@abank_official';
export const pr_page_subscribe_facebook = 'https://www.facebook.com/abank.dp.ua?locale=uk_UA';
export const pr_page_subscribe_facebook_robota =
    'https://www.facebook.com/robotaabank?locale=uk_UA';
export const pr_page_subscribe_instagram = 'https://www.instagram.com/abank_official/';
export const pr_page_subscribe_instagram_robota = 'https://www.instagram.com/robotaabank/';
export const pr_page_subscribe_youtube = 'https://www.youtube.com/channel/UC5UByAW-8_zgjZoAu8LbvRQ';
export const govUaRia =
    'https://bank.gov.ua/ua/payments/payment-systems/8508e8dff4eed335fd6a56784830859f#%D0%90%D0%91%20%22%D0%A3%D0%9A%D0%A0%D0%93%D0%90%D0%97%D0%91%D0%90%D0%9D%D0%9A%22';
export const govUaMoneyGram =
    'https://bank.gov.ua/ua/payments/payment-systems/e849522905cd2225972b7bc154bc35e3#%D0%90%D0%91%20%22%D0%A3%D0%9A%D0%A0%D0%93%D0%90%D0%97%D0%91%D0%90%D0%9D%D0%9A%22';
export const govUaGLOBUS =
    'https://bank.gov.ua/ua/payments/payment-systems/9a6c25bf47173dc2f6567a79d9ad2f0f';
export const mapFrameUrl = 'https://map.a-bank.com.ua/?lang=uk&site_map=2';

export const FRPgovLink = 'https://zakon.rada.gov.ua/laws/show/28-2020-%D0%BF#Text';
